import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Notification, STATUS_TYPES } from 'dyl-components';
import "./index.scss"
import importActions from 'actions/import_data';

const Results = ({ module, uploadId, getDataMappingValues, checkIsInLoading, recordsCount }) => {

    const dispatch = useDispatch();

    const [importResults, setImportResults] = useState({});

    const [isLoadingResults, setIsLoadingResults] = useState(false);
    const [isFailedToUpload, setIsFailedToUpload] = useState(false);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                setIsLoadingResults(true)
                if (uploadId) {
                    dispatch(importActions.isReadingImportResults({ upload_id: uploadId })).then(result => {
                        if (result.done) {
                            setIsLoadingResults(false)
                            setImportResults(result);
                        } else {
                            setTimeout(() => {
                                fetchResults();
                            }, 10000);
                        }
                    });
                }
            } catch (e) {
                console.log(e);
                setIsFailedToUpload(true);
                Notification.alert('Failed to add data mappings!', STATUS_TYPES.ERROR);
            }
        };
        fetchResults();
    }, [uploadId, dispatch]);

    return (
        <div className='Results'>
            <h3 className='Results_Header'>Mapping Results</h3>

            {!uploadId && !isFailedToUpload ? <div>
                <b>Successfully added data mappings!</b>
            </div>
                :
                <div>
                    {checkIsInLoading((isLoadingResults) && !isFailedToUpload) ? <p>Mapping in progress...</p> :
                        <>
                            <p><b>New {module === 'Opportunity' ? 'opportunities' : `${module}s`} created:</b> {importResults?.created || 0}</p>
                            <p><b>Duplicates found:</b> {importResults?.duplicates || 0}</p>
                            {getDataMappingValues('group')?.value !== 'none' && <p><b>Added to group/subgroup:</b> {importResults?.group}</p>}
                            {getDataMappingValues('campaign') !== 'none' && <p><b>Added to campaign:</b>  {importResults?.campaign} </p>}
                            {(importResults?.rejected && !isFailedToUpload) ? <>
                                <hr />
                                <p className='Rejected_Records'><b>Rejected records:</b> {importResults?.rejected}</p>
                            </> :
                                <p><b>Rejected records:</b> {0}</p>
                            }
                            {isFailedToUpload ? <>
                                <hr />
                                <p className='Rejected_Records'><b>System failed to upload:</b> {recordsCount}</p>
                            </> : ""}
                        </>
                    }
                </div>
            }
        </div>
    )
}

export default Results;
